module.exports = "https://static.wmbcdn.com/uniweb/images/e9a1c0e78b7d1f3839a7e2ae7fd5c33e.svg";